export const DETAILS = 'Details';
export const NO_DETAILS_AVAILABLE = 'No Details Available';
export const ASSETS = 'Assets';
export const TIME_SERIES = 'Time Series';
export const FILES = 'Files';
export const EVENTS = 'Events';
export const SEQUENCES = 'Sequences';
export const PREVIEW = 'Preview';
